import { enableAutoTrack, makeTracker } from './auto';
import { mixpanel } from './mixpanel';
import { yandexMetric } from './yandex-metric';

export const track = makeTracker((event, props) => {
  mixpanel.track(event, props);
  yandexMetric.reachGoal(event, props);
});

export { enableAutoTrack, mixpanel, yandexMetric };
export default track;
